export enum SequenceOnHoldReasonTypeEnum {
  EmailConnection = 'EMAIL_CONNECTION',
  InternalError = 'INTERNAL_ERROR',
}
